import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from 'ui/InputSelect'
import { Podcast, OctagonAlert, Speech, Blocks, HandFist, MessageCircle, MessageSquarePlus, Repeat, Group } from 'lucide-react'

interface Props {
    selectedType: string
    onTypeChange: (newType: string) => void
}

const EntitiesTypeSelector = ({ selectedType, onTypeChange }: Props) => {

    const handleTypeChange = (newType: string) => {
        onTypeChange(newType)
    }

    return (
        <div className=''>
            <Select value={selectedType} onValueChange={(value: string) => handleTypeChange(value)}>
                <SelectTrigger className="px-3 py-2">
                    <SelectValue placeholder="Type" />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="all">Everything</SelectItem>
                    <SelectItem value="issues">
                        <div className="flex items-center gap-2">
                            <Podcast className="size-4" />
                            <span>Issues</span>
                        </div>
                    </SelectItem>
                    <SelectItem value="impacts">
                        <div className="flex items-center gap-2">
                            <OctagonAlert className="size-4" />
                            <span>Impacts</span>
                        </div>
                    </SelectItem>
                    <SelectItem value="solutions">
                        <div className="flex items-center gap-2">
                            <Blocks className="size-4" />
                            <span>Solutions</span>
                        </div>
                    </SelectItem>
                    <SelectItem value="actions">
                        <div className="flex items-center gap-2">
                            <HandFist className="size-4" />
                            <span>Actions</span>
                        </div>
                    </SelectItem>
                    <SelectItem value="collections">
                        <div className="flex items-center gap-2">
                            <Group className="size-4" />
                            <span>Collections</span>
                        </div>
                    </SelectItem>
                    <SelectItem value="teabates">
                        <div className="flex items-center gap-2">
                            <Speech className="size-4" />
                            <span>Teabates</span>
                        </div>
                    </SelectItem>
                    <SelectItem value="comments">
                        <div className="flex items-center gap-2">
                            <MessageCircle className="size-4" />
                            <span>Comments</span>
                        </div>
                    </SelectItem>
                    <SelectItem value="resteeps">
                        <div className="flex items-center gap-2">
                            <Repeat className="size-4" />
                            <span>Resteeps</span>
                        </div>
                    </SelectItem>
                    <SelectItem value="user-feedback">
                        <div className="flex items-center gap-2">
                            <MessageSquarePlus className="size-4" />
                            <span>Feedback</span>
                        </div>
                    </SelectItem>
                </SelectContent>
            </Select>
        </div>
    )
}

export default EntitiesTypeSelector 